<template>
  <span>
    <v-dialog max-width="1000px" persistent :value="true">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("travelService.orderRail") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <multiple-user-select
              :birth-date-required="$store.getters['userProperties'].system_settings.travel_service_rail_insurance === insuranceTypeID.INSURANCE_ADD"
            />
            <v-row dense>
              <v-col class="px-2" cols="12">
                <v-select
                  :items="availableClasses"
                  :label="$t('travelService.class') + '*'"
                  :rules="[validatorIsRequired]"
                  v-model="contextModel.travelServiceOrderItemRail.seat_class"
                /> </v-col
              ><v-col class="px-2" cols="12" sm="6">
                <location-ajax-select
                  :label="$t('travelService.departureRailPlace') + '*'"
                  :placeholder="$t('travelService.enterCountry')"
                  :rules="[validatorIsRequired]"
                  :select-model.sync="contextModel.travelServiceOrderItemRail.start_place_id"
                  type="train_station"
                /> </v-col
              ><v-col class="px-2" cols="12" sm="6">
                <location-ajax-select
                  :label="$t('travelService.arrivalRailPlace') + '*'"
                  :placeholder="$t('travelService.enterCountry')"
                  :rules="[validatorIsRequired]"
                  :select-model.sync="contextModel.travelServiceOrderItemRail.end_place_id"
                  type="train_station"
                /> </v-col
              ><v-col class="px-2" cols="12" sm="6">
                <date-picker
                  :label="$t('travelService.departureRailDate') + '*'"
                  :max="contextModel.travelServiceOrderItemRail.return_date"
                  :model.sync="contextModel.travelServiceOrderItemRail.start_date"
                  :rules="[validatorIsRequired, validatorIsFutureDate]"
                /> </v-col
              ><v-col class="px-2" cols="12" sm="6">
                <time-picker
                  :label="$t('travelService.departureRailTime')"
                  :model.sync="contextModel.travelServiceOrderItemRail.start_time"
                  :placeholder="$t('travelService.any')"
                  prepend-icon=""
                /> </v-col
              ><v-col class="px-2" cols="12" sm="6">
                <v-checkbox :label="$t('travelService.isReturnRoute')" v-model="isReturnRoute" />
              </v-col>
              <v-col class="px-2" cols="12" sm="6" v-if="isReturnRoute">
                <date-picker
                  :label="$t('travelService.returnRailDate') + '*'"
                  :min="contextModel.travelServiceOrderItemRail.start_date"
                  :model.sync="contextModel.travelServiceOrderItemRail.return_date"
                  :rules="[validatorIsRequired, validatorIsFutureDate]"
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6" v-if="isReturnRoute">
                <time-picker
                  :label="$t('travelService.returnRailTime')"
                  :model.sync="contextModel.travelServiceOrderItemRail.return_time"
                  :placeholder="$t('travelService.any')"
                  prepend-icon=""
                />
              </v-col>
              <v-col class="px-2" cols="12" sm="6">
                <cost-centre-select :value.sync="contextModel.cost_centre" />
              </v-col>
              <v-col class="px-2" cols="12">
                <v-text-field :label="$t('global.comment')" v-model="contextModel.comment" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid" @click.native="save" color="blue darken-1" text>Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import LocationAjaxSelect from "../CustomInputComponents/LocationAjaxSelect";
import DatePicker from "../CustomInputComponents/DatePicker";
import TimePicker from "../CustomInputComponents/TimePicker";
import MultipleUserSelect from "./MultipleUserSelect";
import CostCentreSelect from "./CostCentreSelect";
import { allRailClassTypes } from "../../staticData/TravelServiceTypes";
import vue from "../../main";
import moment from "moment";
import { insuranceTypeID } from "../../staticData/TravelServiceTypes";

export default {
  name: "OrderServiceRail",
  components: {
    CostCentreSelect,
    MultipleUserSelect,
    TimePicker,
    DatePicker,
    LocationAjaxSelect
  },
  data: () => ({
    formValid: true,
    contextModel: null,
    is_return_route: false,
    insuranceTypeID
  }),
  watch: {
    contextModel: {
      deep: true,
      handler() {
        if (JSON.stringify(this.contextModel) !== JSON.stringify(this.editedTravelServiceOrderItem)) {
          this.updateVuexState();
        }
      }
    },
    editedTravelServiceOrderItem: {
      deep: true,
      handler(val) {
        this.contextModel = JSON.parse(JSON.stringify(val));
      }
    }
  },
  computed: {
    isReturnRoute: {
      get() {
        return this.is_return_route || this.contextModel.travelServiceOrderItemRail.return_date !== null;
      },
      set(val) {
        if (val) {
          this.is_return_route = true;
        } else {
          this.is_return_route = false;
          this.contextModel.travelServiceOrderItemRail.return_date = null;
          this.contextModel.travelServiceOrderItemRail.return_time = null;
        }
      }
    },
    availableClasses: allRailClassTypes,
    editedTravelServiceOrderItem() {
      return this.$store.state.TravelService.editedTravelServiceItem;
    }
  },
  methods: {
    validatorIsRequired(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    },
    validatorIsFutureDate(v) {
      return (
        moment(v)
          .endOf("day")
          .isAfter(moment()) || vue.$t("global.error.dateLaterThanNow")
      );
    },
    updateVuexState() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", this.contextModel);
    },
    cancel() {
      this.$store.commit("TravelService/setEditedTravelServiceItem", null);
      this.$store.commit("TravelService/setOldTravelServiceItem", null);
      this.$refs.form.resetValidation();
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("TravelService/saveEditedServiceItem");
      }
    }
  },
  created() {
    //this.contextModel.is_insurance = parseInt(this.$store.getters["userProperties"].system_settings.travel_service_rail_insurance) === 1;
    this.contextModel = JSON.parse(JSON.stringify(this.editedTravelServiceOrderItem));
  }
};
</script>

<style scoped></style>
